<template>
    <div>
      <!-- Add Google Fonts -->
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&family=Lobster&family=Open+Sans:wght@400;700&family=Pacifico&family=Playfair+Display:wght@400;700&family=Poppins:wght@400;700&family=Raleway:wght@400;700&family=Roboto:wght@400;700&family=Rock+Salt&display=swap" rel="stylesheet">
  
      <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
          <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
          <app-navbar></app-navbar>
  
          <div class="container-fluid mt-5">
            <div class="col-sm-12">
              <vs-breadcrumb align="left" :items="[
                { title: 'You are here : ' },
                {
                  title: 'Dashboard',
                  url: '/#/dashboard/Trainee/traineeDashboard'
                },
                {
                  title: 'Certificate',
                  active: true
                }
              ]"></vs-breadcrumb>
  
              <div class="container-fluid">
                <iframe
                  id="analytics-iframe"
                  v-if="iframeAllowed"
                  :src="iframeUrl"
                  width="100%"
                  height="1300"
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from "./Navbar";
  import Sidebar from "./Sidebar";
  import axios from "axios";
  
  export default {
    data: () => ({
      isSidebar: false,
      iframeUrl: '',
      iframeAllowed: false,
      trainingCode: '',
      trainingId: '',
      userId: ''
    }),
  
    mounted() {
      this.trainingCode = this.$route.query.trainingId;
      this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      this.userId = currentUser?.id;
  
      this.openLoading();
  
      axios.get(
        `${this.BASEPATHDYNAMIC}/trainee/training/single/${this.trainingCode}/get`
      )
      .then(response => {
        if (response.data.unAuth) {
          this.handleUnauthorized();
        }
        if (response.data.tokenExpired) {
          this.handleTokenExpired(response.data.tokenExpired);
        }
  
        this.trainingId = response.data.id;
        this.title = response.data.title;
        this.trainingData = response.data;
  
        // ✅ Set iframe URL and allow iframe display
        const basePath = process.env.VUE_APP_BASE_PATH;
                         if (basePath.includes("dev.tmisodc.org")) {
                           this.iframeUrl = `https://www.dev.tmisodc.org/certificates/view_certificate.php?tid=${this.trainingId}&uid=${this.userId}`;
                         } else {
                           this.iframeUrl = `https://www.tmisodc.org/certificates/view_certificate.php?tid=${this.trainingId}&uid=${this.userId}`;
                         }
        
        this.iframeAllowed = true;
        this.closeLoading();
      })
      .catch(error => {
        this.closeLoading();
        this.$toasted.global.errorMsg('Failed to load training data');
        console.error("Error fetching training data:", error);
      });
    },
  
    components: {
      "app-navbar": Navbar,
      "app-sidebar": Sidebar
    },
  
    methods: {
      openLoading() {
        this.$vs.loading({ type: "material" });
      },
      closeLoading() {
        this.$vs.loading.close();
      },
      handleUnauthorized() {
        this.$toasted.global.errorMsg("Unauthorized access.");
        this.$router.push("/login");
      },
      handleTokenExpired(msg) {
        this.$toasted.global.errorMsg(msg);
        this.$router.push("/login");
      }
    }
  };
  </script>
  
  <style scoped>
  #menu-toggle {
    display: none;
  }
  
  @media (max-width: 768px) {
    #menu-toggle {
      display: block;
    }
  }
  
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f4f4f4;
  }
  </style>
  